import { propOr, pathOr, compose, filter, map, prepend, pluck } from 'ramda'
import { createSelector } from 'reselect'

import moment from 'utils/moment'

export const notificationsSelector = createSelector(
  state => state,
  state => compose(
    map(item => {
      const date = propOr('', 'DATE', item)
      return {
        ...item,
        DATE: date ? moment(date, 'X').locale('ru').format('DD.MM.YYYY') : ''
      }
    }),
    propOr([], 'notifications')
  )(state)
)

export const filtersSelector = createSelector(
  state => state,
  state => {
    const filters = propOr([], 'filters', state)
    const aggregation = compose(
      map(item => {
        const values = compose(
          prepend({ title: 'Все', value: '' }),
          map(itemVal => ({
            title: propOr('', 'VALUE', itemVal),
            value: propOr('', 'ID', itemVal)
          })),
          propOr([], 'VALUES')
        )(item)
        return {
          ...item,
          VALUES: values
        }
      }),
      filter(item => propOr('', 'TYPE', item) !== 'RANGE'),
      propOr([], 'AGGREGATION')
    )(filters)
    const sort = compose(
      map(item => ({
        title: propOr('', 'TITLE', item),
        value: `${propOr('','SORT', item)}_${propOr('', 'ORDER', item)}`
      })),
      pathOr([], ['NAV', 'SORT'])
    )(filters)
    const count = pathOr(0, ['NAV', 'CNT'], filters)
    return { aggregation, sort, count }
  }
)

export const checkedItemsSelector = createSelector(
  state => state,
  state => propOr([], 'checkedItems', state)
)

export const notificationsNotViewedSelector = createSelector(
  state => state,
  state => {
    const items = compose(
      map(item => ({
        id: propOr('', 'ID', item),
        type: propOr('', 'TYPE', item)
      })),
      filter(item => !propOr(false, 'VIEWED', item)),
      propOr([], 'notifications')
    )(state)
    return {
      items,
      ids: pluck('id', items)
    }
  }
)

export const errorMessageSelector = createSelector(
  state => state,
  state => propOr('', 'error', state)
)
